import { createSlice } from "@reduxjs/toolkit";

const initialUserState = {
    id: null,
    email: "",
    firstName: "",
    lastName: "",
    package: "",
    avatar: "",
    totalUnread: "",
};

export const userSlice = createSlice({
    name: "user",
    initialState: {
        user: initialUserState,
    },
    reducers: {
        setUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
        },
        resetUser: (state) => {
            state.user = initialUserState;
        },
    },
});

export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
